
import React, { useEffect, useState } from 'react';

const IPGrid = ({ rows, header, row }) => {
    let [page, setPage] = useState(1);
    let [pageSize, setPageSize] = useState(10);
    let [displayRows, setDisplayRows] = useState([]);

    let [pages, setPages] = useState([]);

    useEffect(() => {
        setDisplayRows((!rows && rows.length === 0) ? [] : rows.slice((page - 1) * pageSize, page * pageSize))
        let ps = [];
        let maxPage = parseInt((rows || []).length / pageSize) + ((rows || []).length % pageSize > 0 ? 1 : 0);
        for (let i = 1; i <= maxPage; i++) {
            ps.push(i);
        }
        setPages(ps);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rows, pageSize, page]);

    useEffect(() => {
        setPage(1);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageSize])

    return (

        <div className="row">
            <div className="col-md-3">

                <label>Покажи</label>
                <select
                    className="form-control"
                    value={pageSize}
                    onChange={(e) => setPageSize(e.target.value)}
                >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
            </div>
            <div className="col-md-3">
                {rows && <span>Открити са {rows.length} елемента</span>}
            </div>
            <div className="col-md-12">
                {header()}
            </div>

            {
                displayRows.map((item, index) =>
                    <div className="col-md-12" key={index}>
                        {row(item)}
                    </div>
                )
            }
            <div className="col-md-12">
                {pages.map((item) =>
                    // eslint-disable-next-line eqeqeq
                    item == page ? <b>{page}</b> :
                        <button className="btn btn-light" onClick={() => setPage(item)}>{item}</button>

                )}
            </div>


        </div>
    )
}

export default IPGrid;